import React, { useEffect, useState } from "react";
import { getStorage } from "../../../services/localStorageService";
import DriverCard from "../../UI/DriverCard";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { toggleSidebar } from "../../../store/actions/group.action";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import SelectDateModal from "../../modals/task-manager/SelectDateModal";
import IconButton from "../../UI/IconButton";
import CreateReserveModal from "../../modals/fleet-reserve/CreateReserveModal";
import CreateUserReserveModal from "../../modals/fleet-reserve/CreateUserReserveModal";
import SearchInput from "../../SearchInput";

const HistorySubHeader = (props) => {
  const [selectDate, setSelectDate] = useState(false);
  const [serviceCenter, setServiceCenter] = useState(
    getStorage("__fleetReservation__", "object"),
  );
  const [createTask, setCreateTask] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [time, setTime] = useState(Date.now());
    const activeDriver = useSelector(
      (state) => state.fleetReserveReducer.activeDriver,
    );

  //   const loadServiceCenter = async () => {
  //     try {
  //       const response = await ServiceCenterRequest("/service-center/profile");
  //       setServiceCenter(response);
  //     } catch (error) {
  //       setServiceCenter(getStorage("__fleetReservation__", "object"));
  //     }
  //   };

  //   useEffect(() => {
  //     loadServiceCenter();
  //   }, []);
const toggleCreateTaskModal = () => setCreateTask(!createTask);
  const onChangeTime = async (_value) => {
    var _from, _to;

    switch (_value) {
      case "Today":
        _from = _to = new Date();
        break;

      case "Yesterday":
        _from = _to = new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000);
        break;

      case "Last Week":
        _from = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000);
        _to = new Date();
        break;

      case "Current Month":
        _from = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        _to = new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0,
          23,
          59,
          59,
          999,
        );
        break;
    }

    props.setInterval(_value);
    props.setStartDate(_from);
    props.setEndDate(_to);
  };

  const toggleSelectDateModal = () => {
    props.setInterval("Custom Date");
    setSelectDate(!selectDate);
  };
  const onSelectAnyTime = async (_from, _to) => {
    setSelectDate(!selectDate);
    props.setStartDate(_from);
    props.setEndDate(_to);
  };
  return (
   <div className="d-flex justify-content-between align-items-center border-bottom p-2">
  <SelectDateModal
    show={selectDate}
    onSet={onSelectAnyTime}
    toggleModal={toggleSelectDateModal}
    
  />
   <CreateUserReserveModal
          show={createTask}
          activeDriver={activeDriver ? activeDriver : false}
          status={activeDriver ? "Assigned" : "Not Assigned"}
          toggleModal={toggleCreateTaskModal}
          startDate={props.startDate}
          endDate={props.endDate}
        />

  {/* Left Side */}
  <DriverCard driver={false} placeholder="FleetReservation" />

  {/* Right Side: Date Dropdown + Go Back */}
  <div className="d-flex ">
     <SearchInput
     className="mb-1"
              placeholder="Search..."
              value={props.search}
              text={props.search}
              onSearch={(e) => props.setSearchText(e.target.value)}
              onClear={() => props.setSearchText("")}
              iconStyle={{ position: "relative", right: "11%", marginTop: 0 ,marginBottom:2}}
              containerClass="align-item-center"
            />
    <span className="mt-2" style={styles.calendarLabel}>{props.interval}</span>

     <Dropdown className="mr-4 mt-2">
                <Dropdown.Toggle
                  id="dropdown-basic"
                  className="btn-white after-none shadow-none pt-1 pb-1"
                >
                  <i className="fa fa-caret-down"></i>
                </Dropdown.Toggle>
    
                <Dropdown.Menu>
                  <Dropdown.Item>
                    <div className="row">
                      <div
                        className="col-md-12 pl-0"
                        onClick={() => onChangeTime("Today")}
                      >
                        <i className="fa fa-calendar  mt-2_5 text-success ml-2 font-12"></i>
                        <span className="font-12 text-black ml-2 mt-2 ml-1">
                          Today
                        </span>
                      </div>
                      <div
                        className="col-md-12 pl-0"
                        onClick={() => onChangeTime("Yesterday")}
                      >
                        <i className="fa fa-calendar  mt-2_5 text-success ml-2 font-12"></i>
                        <span className="font-12 text-black ml-2 mt-2 ml-1">
                          Yesterday
                        </span>
                      </div>
    
                      <div
                        className="col-md-12 pl-0"
                        onClick={() => onChangeTime("Last Week")}
                      >
                        <i className="fa fa-calendar  mt-2_5 text-success ml-2 font-12"></i>
                        <span className="font-12 text-black ml-2 mt-2 ml-1">
                          Last Week
                        </span>
                      </div>
    
                      <div
                        className="col-md-12 pl-0"
                        onClick={() => onChangeTime("Current Month")}
                      >
                        <i className="fa fa-calendar  mt-2_5 text-success ml-2 font-12"></i>
                        <span className="font-12 text-black ml-2 mt-2 ml-1">
                          Current Month
                        </span>
                      </div>
    
                      <div
                        className="col-md-12 pl-0"
                        onClick={toggleSelectDateModal}
                      >
                        <i className="fa fa-calendar  mt-2_5 text-success ml-2 font-12"></i>
                        <span className="font-12 text-black ml-2 mt-2 ml-1">
                          Custom Date
                        </span>
                      </div>
                    </div>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

   <IconButton
   className="mt-2"
              type="button"
              label="Create Reservation"
              buttonstyle={styles.btn}
              onClick={toggleCreateTaskModal}
              
            />
  </div>
</div>

  );
};

export default HistorySubHeader;

const styles = {
  calendarLabel: {
    border: "1px solid rgb(204, 204, 204)",
    padding: "6px 7px",
    borderRadius: 5,
    fontSize: "12px",
    margin: " 0px 10px",
    height: 34.73,
  },
    btn: {
    fontSize: "10px",
    padding: "5px",
    color: "#fff",
    backgroundColor: "#3166ee",
    borderColor: "#3166ee",
    height: 34.73,
    textTransform: "capitalize",
  },
};
